"use strict";
'use es6'; // Added this as a one off to fix the post filter widget. This wiring was
// previously included in public_common via common_init.js

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var PostFilterWidget = /*#__PURE__*/function () {
  function PostFilterWidget() {
    (0, _classCallCheck2.default)(this, PostFilterWidget);

    this.getShowAllFiltersLinkEventHandler = function (link) {
      return function (event) {
        var children = link.previousElementSibling.children;

        if (children) {
          [].slice.call(children, 0).forEach(function (child) {
            child.style.display = 'block';
          });
        }

        link.style.display = 'none';
        event.preventDefault();
        event.stopPropagation();
      };
    };
  }

  (0, _createClass2.default)(PostFilterWidget, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      var filterLinksNodes = [].slice.call(document.querySelectorAll('.filter-expand-link'), 0);
      filterLinksNodes.forEach(function (link) {
        link.addEventListener('click', _this.getShowAllFiltersLinkEventHandler(link));
      });
    }
  }]);
  return PostFilterWidget;
}();

exports.default = PostFilterWidget;
module.exports = exports.default;